import { defineStore } from 'pinia'
import { getConfig } from '@/config'

type Theme = 'light' | 'dark'

export const useThemeStore = defineStore('theme', {
  state: () => {
    // Get default theme from config if localStorage doesn't have a value
    const storedTheme = localStorage.getItem('theme') as Theme | null
    const config = getConfig()
    const defaultTheme = (config.defaultMode || 'light') as Theme
    
    return {
      theme: storedTheme || defaultTheme
    }
  },

  actions: {
    setTheme(newTheme: Theme) {
      this.theme = newTheme
      localStorage.setItem('theme', newTheme)
      document.documentElement.classList.toggle('dark', newTheme === 'dark')
    },

    init() {
      document.documentElement.classList.toggle('dark', this.theme === 'dark')
    }
  }
})
